import React, { Component } from 'react';
import TableC from '../../../basicElement/TableC';

class List extends Component {
    getColumns = () => {
        const { hasAuth } = this.props;
        const columns = [{
            title: 'BA工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 100,
        }, {
            title: 'BA姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 100,
        }, {
            title: '职位级别',
            dataIndex: 'positionName',
            key: 'positionName',
            width: 100,
        }, {
            title: '主管领导工号',
            dataIndex: 'leaderCode',
            key: 'leaderCode',
            width: 100,
        }, {
            title: '主管领导姓名',
            dataIndex: 'leaderName',
            key: 'leaderName',
            width: 100,
        }, {
            title: '状态',
            dataIndex: 'status',
            key: 'status',
            width: 100,
        }, {
            title: '组长工号',
            dataIndex: 'baLeaderCode',
            key: 'baLeaderCode',
            sorter: true,
            width: 100,
        }, {
            title: '组长姓名',
            dataIndex: 'baLeaderName',
            key: 'baLeaderName',
            sorter: true,
            width: 100,
        }];
        if (hasAuth) {
            columns.push({
                title: '操作',
                dataIndex: 'operation',
                key: 'operation',
                width: 120,
                render: (text, record) => {
                    const { baOwnStatus } = record;
                    const disabled = baOwnStatus === 'ACTIVE';
                    return (
                        <span>
                            <a disabled={disabled} onClick={() => this.props.distributeGroupLeader(record)}>分配组长</a>
                            <span className="ant-divider" />
                            <a disabled={disabled} onClick={() => this.props.delete(record)}>删除</a>
                        </span>
                    );
                },
            });
        }
        return columns;
    }

    handleTableChange = (params) => {
        this.props.onChange(params);
    }

    render() {
        const { loading, pagination, sortParams, data } = this.props;
        return (
            <div>
                <TableC
                    data={data}
                    scrollY={500}
                    loading={loading}
                    columns={this.getColumns()}
                    pagination={pagination}
                    sortParams={sortParams}
                    onChange={this.handleTableChange}
                />
            </div>
        );
    }
}

export default List;


// WEBPACK FOOTER //
// ./src/components/contractManagement/baGrouping/components/List.js